import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=2dd6cf9f&"
import script from "./ai.vue?vue&type=script&lang=js&"
export * from "./ai.vue?vue&type=script&lang=js&"
import style0 from "./ai.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports